import { TFunction } from 'i18next';
import * as yup from 'yup';
import {
  ContractResponseDto,
  ContractResponseDtoContractStatusEnum,
  SubmissionResponseDto,
} from 'libs/pinnacle-sdk';
import { isCancelledOrNTUContract } from '../validation-helper';

export interface IncidentalFormValues {
  incidental: boolean;
  incidentalCountry: string[];
  underwritingComments?: string;
  primaryRiskLocation?: string;
  stockDeclaration: boolean;
}

export const getInitialIncidental = (
  submission: SubmissionResponseDto,
  contract?: ContractResponseDto
): IncidentalFormValues => {
  return {
    incidental: contract?.incidental || false,
    incidentalCountry: contract?.incidentalCountry || [],
    underwritingComments: contract?.underwritingComments,
    primaryRiskLocation: submission.keyRiskLocation,
    stockDeclaration: contract?.stockDeclaration || false,
  };
};

export const getIncidentalValidationSchemaShape = (t: TFunction) => ({
  incidental: yup.boolean().when('contractStatus', {
    is: ContractResponseDtoContractStatusEnum.Bound,
    then: () =>
      yup
        .boolean()
        .required(
          t('validation.required', { field: t('contractDetail.incidental') })
        ),
  }),
  incidentalCountry: yup
    .array()
    .of(yup.string())
    .when(['contractStatus', 'incidental'], {
      is: (
        contractStatus: ContractResponseDtoContractStatusEnum,
        incidental: boolean
      ) => !isCancelledOrNTUContract(contractStatus) && incidental === true,
      then: () =>
        yup
          .array()
          .of(yup.string())
          .min(
            1,
            t('validation.required', {
              field: t('contractDetail.incidentalCountry'),
            })
          ),
    }),
  underwritingComments: yup.string().optional(),
  primaryRiskLocation: yup.string(),
  stockDeclaration: yup.boolean(),
});
